import BaseApiService from '@/services/common/api/baseApiService';

class AuthorizationService extends BaseApiService {
  login(loginInfo) {
    return this.makeRequest(this.httpClient
      .post(this.apiRoutes.userLogin, loginInfo));
  }

  logout() {
    return this.makeRequest(this.httpClient
      .get(this.apiRoutes.userLogout));
  }

  getUserInfo() {
    return this.makeRequest(this.httpClient
      .get(this.apiRoutes.userInfo));
  }
}

export default AuthorizationService;
